export default {
  PropertyOwners: [],
  PropertyOwner: {},
}